function ConfirmEmail() {
    return (
        <div className="pageContainer">
            <h1>Deine Registrierung war erfolgreich!</h1>
            <p>
                Du hast eine Email bekommen, in der der Link zum Bestätigen
                deiner Email-Adresse ist. Bitte bestätige deine Email, um dich erfolgreich
                einloggen zu können. Vergiss auch nicht, deinen Spam-Ordner zu checken!
            </p>
        </div>
    );
}

export default ConfirmEmail;